



















































































































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { PicRec, PicTypeRec, PicList, PicListSet, DocRec, DocTypeRec } from '@/interfaces';
import DetailMixin from '@/mixins/DetailMixin';
import PictureListSet from '@/components/PictureListSet.vue';
import ImageUpload from '@/components/ImageUpload.vue';
import FieldDefs from './FieldDefs';
import {commitAddNotification} from '@/store/main/mutations';
import {ProcessStateEnum} from '@/interfaces';
import formatting from '@/formatting';
import { MapObject } from 'vee-validate';
import { appEnv } from '@/env';
import { hasUnsavedUploads, unsavedUploadsWarning } from '@/uploadQueue';


@Component({
  components: {
    PictureListSet, ImageUpload
  }
})
export default class InspectionsDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public items: object[] = [];

  public coordSrc: any = null;
  public coordDst: any = null;

  public recPreparation: object = {};
  public indexPreparation = -1;
  public dialogPreparation = false;
  public dialogDeletePreparation = false;

  public recMeasurement: any = {};
  public indexMeasurement = -1;
  public dialogMeasurement = false;
  public dialogDeleteMeasurement = false;

  public recAction: any = {};
  public dialogAction = false;

  public recDebugResetState: any = {};
  public dialogDebugResetState = false;

  public viewPreparation = true;
  public viewOnsite = false;
  public viewPics = false;

  public cfCOLGenericLeft = ['PROV', 'SIGNALISATIE', 'TYPE', 'TYPE_NETWERK', 'HTPL', 'HATT', 'ITPL', 'IATT', 'PK', 'GELDIG', 'LENGTE', 'REFMETING', 'REFONZEK', 'ZEGELNR', 'RES', 'REDEN', 'WERK'];
  public cfCOLGenericRight = ['RIJRICHTING', 'RICHTING', 'VAR_SNEL', 'SNELHEID', 'THV', 'STRAAT', 'NR', 'BOUWJAAR', 'HASHOUD', 'HASHNIEUW', 'REF_EMT', 'AANVRAGER', 'ONDERWERP', 'FASE', 'VERWERKING'];
  public cfCOL12Left = ['PLAATS_1', 'STRAAT_1', 'KMP_1', 'GPS_1', 'ID_8_1', 'INSTALLATIENR_1', 'ENTRY'];
  public cfCOL12Right = ['PLAATS_2', 'STRAAT_2', 'KMP_2', 'GPS_2', 'ID_8_2', 'INSTALLATIENR_2', 'EXIT'];
  public cfCOLPole = ['CAMNAAM', 'CAMSERIE', 'CAMIP', 'AANT_RS', 'ONDERHOUD'];

  public cfGenericLeft: object[] = [];
  public cfGenericRight: object[] = [];
  public cf12Left: object[] = [];
  public cf12Right: object[] = [];
  public cfPoleMap = {};

  public onsitepicurl: string = '';
  public onsitepicfileurl: string = '';
  public cameraPics: PicListSet[] = [];
  public sitePolePics: PicListSet[] = [];
  public globalPics: PicListSet[] = [];

  public docurl: string = '';
  public docfileurl: string = '';
  public globalDocs: object[] = [];

  public measurements: object[] = [];
  public editMeasurement = false;

  public preparations: object[] = [];
  public editPreparation = false;


  public cfKey(cf) { return cf.name + cf.context_index; }
  public splitCustomFields(customfields) {
    console.log('splitCustomFields');
    const cfGenericLeft: object[] = [];
    const cfGenericRight: object[] = [];
    const cf12Left: object[] = [];
    const cf12Right: object[] = [];
    const cfPoleMap = new Map<number, MapObject>();
    if (customfields) {
      for (const cf of customfields) {
        // console.log(cf.name, cf.context_site_pole, cf.context_index);
        if (cf.hidden_in_frontend) {

        } else if (cf.context_site_pole === false) {
          if (this.cfCOLGenericLeft.indexOf(cf.name) !== -1) {
            cfGenericLeft.push(cf);
          } else if (this.cfCOLGenericRight.indexOf(cf.name) !== -1) {
            cfGenericRight.push(cf);
          } else if (this.cfCOL12Left.indexOf(cf.name) !== -1) {
            cf12Left.push(cf);
          } else if (this.cfCOL12Right.indexOf(cf.name) !== -1) {
            cf12Right.push(cf);
          } else {
            // console.log('Generic(Left)', cf.name, cf.context_site_pole, cf.context_index);
            cfGenericLeft.push(cf);
          }
        } else {
          if (!cfPoleMap.hasOwnProperty(cf.context_index)) {
            cfPoleMap[cf.context_index] = [];
          }
          cfPoleMap[cf.context_index].push(cf);
        }
      }
      this.cfGenericLeft = this.sortFields(cfGenericLeft, this.cfCOLGenericLeft);
      this.cfGenericRight = this.sortFields(cfGenericRight, this.cfCOLGenericRight);
      this.cf12Left = this.sortFields(cf12Left, this.cfCOL12Left);
      this.cf12Right = this.sortFields(cf12Right, this.cfCOL12Right);
      for (const key of Object.keys(cfPoleMap)) {
        this.cfPoleMap[key] = this.sortFields(cfPoleMap[key], this.cfCOLPole);
      }
    }
  }

  public FieldSortIndex(cf, fields) {
    const idx = fields.indexOf(cf.name);
    if (idx !== -1) {
      return idx;
    } else {
      console.log('FieldSortIndex missing key', cf.name);
      return 999;
    }
  }
  public sortFields(result, fields) {
    return result.sort((cf1, cf2) => this.FieldSortIndex(cf1, fields) -  this.FieldSortIndex(cf2, fields));
  }

  public findCustomField(fieldname: string) {
    const ref: any = this.$refs.layout;
    if (ref && ref.rec) {
      for (const cf of ref.rec.customfields) {
        if (cf.name === fieldname) {
          return cf.value;
        }
      }
    }
  }
  public setCustomField(fieldname: string, value: string) {
    const ref: any = this.$refs.layout;
    if (ref && ref.rec) {
      for (const cf of ref.rec.customfields) {
        if (cf.name === fieldname) {
          cf.value = value;
          console.log('setCustomField set:', fieldname, value);
          return;
        }
      }
      console.log('setCustomField not found:', fieldname, value);
    }
  }

  public cfCheckOnsiteVars(rec) {
    if (rec.customfields.length) {
      const missingVars: any[] = [];
      for (const cf of rec.customfields) {
          if (cf.required_onsite && !cf.value) {
            // console.log('cfCheckOnsiteVar RequiredOnsite Missing', cf.name, '<', cf.value, '>', cf);
            missingVars.push(cf);

            rec.onsite_vars_ok = false;
          }
      }
      console.log('cfCheckOnsiteVars', missingVars.length);
      rec.onsite_vars_ok = missingVars.length === 0;
    } else {
      rec.onsite_vars_ok = false;
    }
  }
  public cfCheckOnsiteVar2(rec, cf, cfvue) {
    // console.log('cfCheckOnsiteVar2 ', cfvue);
    // if (cf.check_required_onsite && !cf.value) {
    //   cfvue.setValidateError('oeioei');
    // }
    if (cf.required_onsite) {
      this.cfCheckOnsiteVars(rec);
    }
  }

  public getCameraLabel(contextIndex, rec) {
    if (contextIndex > rec.nr_of_cameras_begin) {
      return 'Exit ' + (contextIndex - rec.nr_of_cameras_begin);
    } else {
      return 'Entry ' + (contextIndex);
    }
  }
  public toggleViewPreparation() {
    this.viewPreparation = !this.viewPreparation;
  }

  public toggleViewOnsite() {
    this.viewOnsite = !this.viewOnsite;
    if (!this.viewOnsite) {
      this.viewPics = false;
    }
  }

  public toggleViewPics() {
    this.viewPics = !this.viewPics;
  }

  public showOnsiteButton(rec) {
    return rec.processstate_id === ProcessStateEnum.ready_for_inspection;
  }
  public get checkWrite() {
    return this.roleCheck('inspection_tc|inspection_site', 'write');
  }
  public get checkRead() {
    return this.roleCheck('inspection_tc|inspection_site', 'read');
  }

  public get canEditPreparation() {
    return this.checkWrite;
  }
  public get canEditMeasurement() {
    return this.checkWrite;
  }
  public get canUploadPics() {
    return this.checkRead;
  }
  public get canUploadFiles() {
    return this.checkWrite;
  }

  public allowInvalidCommit() {
    const ref: any = this.$refs.layout;
    const rec = ref && ref.rec;
    // console.log('allowInvalidCommit', rec && rec.processstate_id === ProcessStateEnum.ready_for_inspection);
    return rec && rec.processstate_id === ProcessStateEnum.ready_for_inspection;
  }

  public showApproveOnsiteVars(rec) {
    return rec.processstate_id === ProcessStateEnum.ready_for_inspection && this.checkWrite;
  }

  public showPreparation(props) {
    return !props.isNew && !this.viewOnsite && this.viewPreparation;
  }

  public showCustomParams(props) {
    return !props.isNew && !this.viewPics && props.rec.sitetype_id;
  }

  public showDebugResetState(props) {
    const isTest = appEnv === 'development' || appEnv === 'staging' || appEnv === 'stagingV2';
    return isTest && props.hasManagePriv;
  }

  public showPics(props) {
    return !props.isNew && props.rec.sitetype_id;
  }

  public showDocs(props) {
    return !props.isNew && props.rec.sitetype_id;
  }

  public showMeasurements(props) {
    return !props.isNew && !this.viewPics && props.rec.sitetype_id;
  }

  public async refreshDocuments(rec) {
    const response = await this.api.postAction(this.$store, this.apiUrl + rec.id + '/checkonedrivefiles', {});
    if (response) {
      const ref: any = this.$refs.layout;
      ref.getRecord();
    }
  }

  public async newPreparation() {
    const form: any = this.$refs.formPreparation;
    if (form) {
      form.resetValidation();
    }
    const ref: any = this.$refs.layout;
    const inspectionrec = ref.rec;
    const rec: any = {id: -1};
    rec.preparationtype_id = null;
    rec.comments = '';
    this.recPreparation = {...rec};
    this.indexPreparation = -1;
    this.dialogPreparation = true;
  }

  public async setPreparation() {
    const form: any = this.$refs.formPreparation;
    if (form.validate()) {
      const ref: any = this.$refs.layout;
      const rec = this.recPreparation as any;
      const inspectionrec = ref.rec;
      if (this.indexPreparation === -1) {
        rec.sequencenr = this.preparations.length + 1;
        const response = await this.api.createRecord(this.$store, this.apiUrl + inspectionrec.id + '/preparations/' , rec);
        if (response && response.data) {
          this.recPreparation = {...response.data};
          this.preparations.push({...this.recPreparation});
        }
      } else {
        const response = await this.api.updateRecord(this.$store, this.apiUrl + 'preparations/' + rec.id, rec);
        if (response && response.data) {
          this.recPreparation = {...response.data};
        }
        this.preparations[this.indexPreparation] = {...rec};
        this.indexPreparation = -1;
      }
      this.dialogPreparation = false;
    }
  }
  public async editPreparationItem(item) {
    this.indexPreparation = this.preparations.indexOf(item);
    this.recPreparation = {...item};
    this.dialogPreparation = true;
  }
  public deletePreparationItem(item) {
    this.indexPreparation = this.preparations.indexOf(item);
    this.dialogDeletePreparation = true;
  }
  public async executeDeletePreparation() {
    const item = (this.preparations as any).at(this.indexPreparation);
    if (item) {
      const response = await this.api.deleteRecord(this.$store, this.apiUrl + 'preparations/' + item.id);
      this.preparations.splice(this.indexPreparation, 1);
    }
  }

  public async newMeasurement() {
    const form: any = this.$refs.formMeasurement;
    if (form) {
      form.resetValidation();
    }
    const ref: any = this.$refs.layout;
    const inspectionrec = ref.rec;
    const url = this.apiUrl + inspectionrec.id + '/routemeasurements/';
    const rec: any = {};
    rec.series_nr = this.measurements.length + 1;
    const richting = this.findCustomField('RICHTING');
    rec.name = `Richting: ${richting}`;
    const response = await this.api.createRecord(this.$store, url, rec);

    if (response) {
        this.recMeasurement = response.data;
        this.measurements.push(this.recMeasurement);
        this.indexMeasurement = this.measurements.length - 1;
        this.prepareAndShowMeasurementRec(inspectionrec);
    } else {
    }
  }

  public async setMeasurement() {
    const form: any = this.$refs.formMeasurement;
    if (form.validate()) {
      const rec = this.recMeasurement;
      if (this.indexMeasurement === -1) {
        // rec.series_nr = this.measurements.length + 1;
        this.measurements.push({...rec});
      } else {
        const url = this.apiUrl + 'routemeasurements/' + rec.id;
        const response = await this.api.updateRecord(this.$store, url, rec);
        if (response && response.data) {
          this.recMeasurement = {...response.data};
          const ref: any = this.$refs.layout;
          const inspectionrec = ref.rec;
          this.prepareAndShowMeasurementRec(inspectionrec);
        }
        this.measurements[this.indexMeasurement] = {...rec};
        this.indexMeasurement = -1;
        await this.measurements_updated();
      }
      this.dialogMeasurement = false;
    }
  }
  public async editMeasurementItem(item) {
    // const ref: any = this.$refs.layout;
    this.indexMeasurement = this.measurements.indexOf(item);
    const url = this.apiUrl + 'routemeasurements/' + item.id;
    const response = await this.api.getRecord(this.$store, url);
    if (response && response.data) {
      this.recMeasurement = {...response.data};
      const ref: any = this.$refs.layout;
      const inspectionrec = ref.rec;
      this.prepareAndShowMeasurementRec(inspectionrec);
    }
  }
  public deleteMeasurementItem(item) {
    // const ref: any = this.$refs.layout;
    this.indexMeasurement = this.measurements.indexOf(item.id);
    this.dialogDeleteMeasurement = true;
  }
  public async executeDeleteMeasurement() {
    // const ref: any = this.$refs.layout;
    const item = (this.measurements as any).at(this.indexMeasurement);
    if (item) {
      const url = this.apiUrl + 'routemeasurements/' + item.id;
      const response = await this.api.deleteRecord(this.$store, url);
      this.measurements.splice(this.indexMeasurement, 1);
      await this.measurements_updated();
    }
  }

  public prepareAndShowMeasurementRec(inspectionrec) {
    const rec = this.recMeasurement;
    const onderwerp = this.findCustomField('ONDERWERP');
    if (onderwerp !== 'Eerste ijk') {
      rec.isRecalibration = true;
      const refmeting = this.findCustomField('REFMETING');
      if (refmeting) {
        rec.isReferenceCalibration = true;
        rec.refMeasurement = Number(refmeting);
        const uncertainty = this.findCustomField('REFONZEK').replace(/,/g, '.').replace(/%/g, '');
        rec.refUncertainty = Number(uncertainty) / 100;
      } else {
        rec.isReferenceCalibration = false;
        rec.oldLength = Number(this.findCustomField('LENGTE')) ;
      }
      this.checkPrevMeasurements(rec);
      // console.log(rec);
    } else { rec.isRecalibration = false; }
    const entryStraat = this.findCustomField('STRAAT_1');
    const entryPlaats = this.findCustomField('PLAATS_1');
    const exitStraat = this.findCustomField('STRAAT_2');
    const exitPlaats = this.findCustomField('PLAATS_2');
    rec.name_entry = `${entryStraat} ${entryPlaats}`;
    rec.name_exit = `${exitStraat} ${exitPlaats}`;


    this.dialogMeasurement = true;
  }
  public sqrt_sqrsum(a: number, b: number) { return Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)); }
  public sqrt_sqrsum3(a: number, b: number, c: number) { return Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2) + Math.pow(c, 2)); }
  public round4(t: number, n1: number, n2: number) { return Math.round(Math.abs(t) / this.sqrt_sqrsum(n1, n2) * 10000) / 10000; }
  public checkPrevMeasurement(rec, avgLength: number, repeatability: number) {
    // console.log('checkPrevMeasurement', avgLength, repeatability, rec.isRecalibration, rec.isReferenceCalibration, rec.refUncertainty, rec.refMeasurement);
    let label = '';
    let ok: boolean|null = null;
    // rec.isReferenceCalibration = true; rec.refMeasurement = 25; rec.refUncertainty = 0.01;
    if (rec.isRecalibration && avgLength) {
      if (rec.isReferenceCalibration) {
        label = 'oud = ' + rec.refMeasurement + 'm/' + rec.refUncertainty + '%';
        // const constant = 0.00028;
        // const combinedUncertainty = 2 * this.sqrt_sqrsum(constant, repeatability);
        // const result = Math.round(Math.abs(avgLength - rec.refMeasurement) / this.sqrt_sqrsum(combinedUncertainty * avgLength, rec.refUncertainty * rec.refMeasurement) * 10000) / 10000;
        // console.log(avgLength, repeatability, rec.refMeasurement, rec.refUncertainty, result);
        // console.log('OBSTAKELS_MOB', this.findCustomField('OBSTAKELS_MOB'));
        const mobileObstacles = this.findCustomField('OBSTAKELS_MOB');
        const TS1 = (mobileObstacles * 0.37) / avgLength;
        const TS2 = this.sqrt_sqrsum3(TS1, 0.040, repeatability);
        const result = this.round4(avgLength - rec.refMeasurement, rec.refUncertainty * rec.refMeasurement, avgLength * TS2);
        console.log(avgLength, mobileObstacles, repeatability, rec.refMeasurement, rec.refUncertainty, TS1, TS2, result);
        ok = result <= 1;
      } else {
        label = 'oud = ' + rec.oldLength + 'm';
        ok = Math.trunc(avgLength) === rec.oldLength;
      }
    }
    return [label, ok];
  }
  public checkPrevMeasurements(rec) {
    [rec.recal_label_1, rec.recal_ok_1] = this.checkPrevMeasurement(rec, rec.result_avg_1, rec.result_rep_1);
    [rec.recal_label_2, rec.recal_ok_2] = this.checkPrevMeasurement(rec, rec.result_avg_2, rec.result_rep_2);
  }


  public calcDev(list: number[]) {
    const avg = list.reduce((acc, n) => acc + n, 0) / list.length;
    const rep = Math.round(Math.sqrt(list.reduce((acc, n) => acc + Math.pow(n - avg, 2), 0) / (list.length - 1)) / avg * 100 * 1000) / 1000;
    return [avg, rep];
  }
  public calcMeasurements(idx) {
    const rec = this.recMeasurement;
    rec.avg_1 = (rec.left_1 + rec.right_1) / 2;
    rec.avg_2 = (rec.left_2 + rec.right_2) / 2;
    rec.avg_3 = (rec.left_3 + rec.right_3) / 2;
    rec.avg_4 = (rec.left_4 + rec.right_4) / 2;

    [rec.result_avg_1, rec.result_rep_1] = this.calcDev([rec.avg_1, rec.avg_2, rec.avg_3]);
    rec.result_ok_1 = rec.result_rep_1 < rec.rep_max_1;
    if (rec.avg_4) {
      [rec.result_avg_2, rec.result_rep_2] = this.calcDev([rec.avg_2, rec.avg_3, rec.avg_4]);
      rec.result_ok_2 = rec.result_rep_2 < rec.rep_max_2;
    } else {
      rec.result_avg_2 = rec.result_rep_2 = 0;
      rec.result_ok_2 = false;
    }
    this.checkPrevMeasurements(rec);
  }

  public async measurements_updated() {
    // console.log('measurements_updated');
    let resultOk = false;
    for (const m of this.measurements) {
      // console.log(m);
      if ((m as any).result_ok_1 || (m as any).result_ok_2) {
        resultOk = true;
        break;
      }
    }
    const ref: any = this.$refs.layout;
    const inspectionrec = ref.rec;
    // console.log('measurements_updated', resultOk, inspectionrec.onsite_measurements_ok);
    if (resultOk !== inspectionrec.onsite_measurements_ok) {
      const url = this.apiUrl + inspectionrec.id;
      const response = await this.api.updateRecord(this.$store, url, {onsite_measurements_ok: resultOk});
      inspectionrec.onsite_measurements_ok = resultOk;
    }
  }


  public async loadedRecord(rec) {
    console.log('loadedRecord', rec);
    // set check_required_onsite based on required_onsite and to_be_planned_for_inspection states
    const isToBePlanned = (rec.processstate_id === ProcessStateEnum.to_be_planned_for_inspection);
    for (const cf of rec.customfields) {
      if (cf.required_onsite) {
        cf.check_required_onsite = !isToBePlanned;
        cf.show_text = cf.title + '*';
      } else {
        cf.check_required_onsite = false;
        cf.show_text = cf.title;
      }
      // cf.show_text += '[' + cf.name + ']';
    }
    this.cfCheckOnsiteVars(rec);
    this.splitCustomFields(rec.customfields);
    {
      const response = await this.api.getTableData(this.$store, this.apiUrl + rec.id + '/routemeasurements/', {per_page: 1000});
      if (response && response.data) {
        this.measurements = response.data.data;
        await this.measurements_updated();
      }
    }
    {
      const response = await this.api.getTableData(this.$store, this.apiUrl + rec.id + '/preparations/', {per_page: 1000});
      if (response && response.data) {
        this.preparations = response.data.data;
        // await this.preparations_updated();
      }
    }
    this.coordSrc = formatting.formatCoordinates(this.findCustomField('GPS_1'));
    this.coordDst = formatting.formatCoordinates(this.findCustomField('GPS_2'));

    if (rec.onsitepicturetypes) {
      this.onsitepicurl = this.apiUrl + rec.id + '/onsitepictures/';
      this.onsitepicfileurl = this.apiUrl + 'onsitepictures/';
      const response = await this.api.getTableData(this.$store, this.onsitepicurl, {per_page: 1000});
      if (response && response.data) {
        const existingPics: PicRec[] = response.data.data as any[] as PicRec[];
        await this.handlePics(rec, existingPics);
      }
    }
    if (rec.documenttypes) {
      this.docurl = this.apiUrl + rec.id + '/docs/';
      this.docfileurl = this.apiUrl + 'docs/';
      const response = await this.api.getTableData(this.$store, this.docurl, {per_page: 1000});
      if (response && response.data) {
        const existingDocs: object[] = response.data.data as any[] as object[];
        await this.handleDocs(rec, existingDocs);
      }
    }
  }

  public async findPics(existingPics: PicRec[], picType: PicTypeRec, contextIndex: number, target: PicList[], counter) {
    const result: PicList = {pictype: picType, pics: []};
    for (const pic of existingPics) {
      if (pic.onsitepicturetype_id === picType.id && pic.context_index === contextIndex) {
        result.pics.push(pic);
      }
    }
    if (picType.min_occurance === 0) {
      // console.log(picType);
    } else {
      if (picType.min_occurance < result.pics.length) {
        const toremove = result.pics.length - picType.min_occurance;
        // console.log(result.pics.length, picType.min_occurance, toremove)
        for (let i = 0; i < toremove; i++) {
          console.log('Will remove onsitepicture', result.pics[picType.min_occurance + i].id);
          const response = await this.api.deleteRecord(null, this.apiUrl + 'onsitepictures/' + result.pics[picType.min_occurance + i].id);
        }
        result.pics.splice(picType.min_occurance);
      } else {
        const toAdd = picType.min_occurance - result.pics.length;
        for (let i = 0; i < toAdd; i++) {
          const pic: PicRec = {id: -1, context_index: contextIndex, onsitepicturetype_id: picType.id, file: null};
          result.pics.push(pic);
        }
      }
    }
    target.push(result);
    if (picType.min_occurance !== 0) {
        for (const pic of result.pics) {
            counter.total += 1;
            if (pic.file) {
              counter.images += 1;
            }
        }
    }
  }

  public async findContextPics(existingPics: PicRec[], picType: PicTypeRec, nrOfContexts: number, target: PicListSet[], counter) {
    for (let i = 0; i < nrOfContexts; i++) {
      await this.findPics(existingPics, picType, i, target[i].pics, counter);
    }
  }

  public async handlePics(rec, existingPics: PicRec[]) {
    // console.log('existingPics', existingPics);
    const picTypes: PicTypeRec[] = rec.onsitepicturetypes;
    const nrOfSitePoles: number = 2;
    const nr_of_cameras_begin: number = rec.nr_of_cameras_begin;
    const nr_of_cameras_end: number = rec.nr_of_cameras_end;
    const nrOfCameras: number = nr_of_cameras_begin + nr_of_cameras_end;
    this.sitePolePics = [];
    this.cameraPics = [];
    this.globalPics = [];
    this.globalPics.push({title: '', pics: []});
    for (let i = 0; i < nrOfSitePoles; i++) {
      this.sitePolePics.push({title: i ? 'Exit' : 'Entry', pics: []});
    }
    for (let i = 0; i < nrOfCameras; i++) {
      this.cameraPics.push({title: 'Camera ' + this.getCameraLabel(i + 1, rec), pics: []});
    }
    const counter = {images: 0, total: 0};
    for (const picType of picTypes) {
      if (picType.context_site_pole) {
        await this.findContextPics(existingPics, picType, nrOfSitePoles, this.sitePolePics, counter);
      } else if (picType.context_camera) {
        await this.findContextPics(existingPics, picType, nrOfCameras, this.cameraPics, counter);
      } else {
        await this.findPics(existingPics, picType, 1, this.globalPics[0].pics, counter);
      }
    }
    // console.log('handlePics', counter.images, counter.total);
    const picsOk = counter.images === counter.total && counter.total !== 0;
    await this.set_pics_ok(picsOk);
  }

  public beforeRouteLeave(to, from, next) {
    // Warn when pictures are still uploading or failed: they are lost when leaving
    if (hasUnsavedUploads() && !window.confirm(unsavedUploadsWarning())) {
      next(false);
    } else {
      next();
    }
  }
  public async pics_updated() {
    const picsOk = (this.$refs.pics_global as any).isComplete && (this.$refs.pics_site as any).isComplete && (this.$refs.pics_camera as any).isComplete;
    await this.set_pics_ok(picsOk);
  }
  public async set_pics_ok(picsOk: boolean) {
    const ref: any = this.$refs.layout;
    const inspectionrec = ref.rec;
    // console.log('set_pics_ok', picsOk, inspectionrec.onsite_pics_ok);
    if (picsOk !== inspectionrec.onsite_pics_ok) {
      const url = this.apiUrl + inspectionrec.id;
      const response = await this.api.updateRecord(this.$store, url, {onsite_pics_ok: picsOk});
      inspectionrec.onsite_pics_ok = picsOk;
    }
  }


  // public findDocs(existingDocs: object[], docType: DocTypeRec, target: DocRec[]) {
  //   for (const curDoc of existingDocs) {
  //     if (curDoc.inspectiondocumenttype_id === docType.id) {
  //       target.push(curDoc);
  //       return;
  //     }
  //   }
  //   const doc: DocRec = {id: -docType.id, inspectiondocumenttype_id: docType.id, inspectiondocumenttype_name: docType.name, file: null};
  //   console.log(doc);
  //   target.push(doc);
  // }


  public async handleDocs(rec, existingDocs: any[]) {
    console.log('handleDocs existingDocs', existingDocs);
    const docTypes: DocTypeRec[] = rec.documenttypes;
    for (const doc of existingDocs) {
      if (doc.signed_file_onedrive_id) {
        doc.show_file = doc.signed_file_onedrive_id;
      } else {
        doc.show_file = doc.file_onedrive_id;
      }
    }

    this.globalDocs = existingDocs;

    // for (const docType of docTypes) {
    //   this.findDocs(existingDocs, docType, this.globalDocs);
    // }
    // console.log('handleDocs', this.globalDocs);
  }

  public async toggle_onsite_vars_approved(inspectionrec) {
    inspectionrec.onsite_vars_approved = !inspectionrec.onsite_vars_approved;
    const url = this.apiUrl + inspectionrec.id;
    const response = await this.api.updateRecord(this.$store, url, {onsite_vars_approved: inspectionrec.onsite_vars_approved});
  }

  public newRecord(rec) {
    console.log('newRecord', rec);
  }

  public gotoHistory(rec) {
    this.$router.push({ path: '/inspectionevents', query: {inspection_id: rec.id}});
  }

  public async updateXLS(rec) {
    const response = await this.api.postAction(this.$store, this.apiUrl + rec.id + '/updatexls', {});
    if (response) {
      // const ref: any = this.$refs.layout;
      const data = response.data as any;
      if (data.status === false) {
        commitAddNotification(this.$store, {content: data.info, color: 'error'});
      }
    }
  }

  public async copytobmidata(rec) {
    const response = await this.api.postAction(this.$store, this.apiUrl + rec.id + '/copytobmidata', {});
    console.log(response);
    if (response) {
      // const ref: any = this.$refs.layout;
      const data = response.data as any;
      if (data.status === false) {
        commitAddNotification(this.$store, {content: data.info, color: 'error'});
      } else {
        commitAddNotification(this.$store, {content: 'Ok', color: 'info'});
      }

    }
  }

  public async copyfrombmidata(rec) {
    const response = await this.api.postAction(this.$store, this.apiUrl + rec.id + '/copyfrombmidata', {});
    console.log(response);
    if (response) {
      // const ref: any = this.$refs.layout;
      const data = response.data as any;
      if (data.status === false) {
        commitAddNotification(this.$store, {content: data.info, color: 'error'});
      } else {
        commitAddNotification(this.$store, {content: 'Ok', color: 'info'});
      }

    }
  }

  public async execAction(rec, action) {
    this.recAction.url = this.apiUrl + rec.id + '/action';
    this.recAction.action = action;
    if (action.reason === true) {
      this.dialogAction = true;
    } else {
      await this.executeAction();
    }
  }
  public async executeAction() {
    const data = {
      nextprocessstate_id: this.recAction.action.state_id
    };
    if (this.recAction.action.reason) {
      (data as any).reason = this.recAction.reason;
    }
    const response = await this.api.postAction(this.$store, this.recAction.url, data);
    if (response) {
      const ref: any = this.$refs.layout;
      ref.rec = response.data;
    }
  }

  public async execDebugResetState(rec) {
    this.recDebugResetState.url = this.apiUrl + rec.id + '/debug_reset_state';
    this.recDebugResetState.processstate_id = rec.processstate_id;
    this.dialogDebugResetState = true;
  }
  public async executeDebugResetState() {
    const data = {};
    const params = {processstate_id: this.recDebugResetState.processstate_id};
    const response = await this.api.postAction(this.$store, this.recDebugResetState.url, data, params);
    if (response) {
      const ref: any = this.$refs.layout;
      ref.getRecord();
    }

  }

  public checkInspector(inspectorId) {
    const inspector1: any = this.$refs.inspector1;
    const result = inspector1.findOptionRecForId(inspectorId);
    if (result) {
      if (result.role.includes('assistent')) {
        return '';
      } else {
        return result.text;
      }
    } else {
      return '';
    }

  }

  public checkInspectors(rec) {
    // console.log('checkInspectors >', rec.inspector1_id, rec.inspector2_id, rec.inspector3_id);
    // const i1 = rec.inspector1_id;
    const i2 = rec.inspector2_id;
    let i3 = rec.inspector3_id;
    if (i3 && (i3 === i2)) {
      i3 = null;
      this.$set(rec, 'inspector3_id', i3);
    }

    if (this.$refs.inspector1) {
      const inspectors = [this.checkInspector(rec.inspector3_id), this.checkInspector(rec.inspector2_id), this.checkInspector(rec.inspector1_id)];
      const werk = inspectors.reduce((pre, inspector) => (pre ? pre + ', ' : '') + inspector, '');
      // console.log('werk', werk)
      this.setCustomField('WERK', werk);
    }
    // console.log('checkInspectors <>', rec.inspector1_id, rec.inspector2_id, rec.inspector3_id);
  }


}
